export const Result = {
  CHANGE_STEP: 'CHANGE_STEP',
  SUCCESS: 'SUCCESS',
  REQUIRE_AUTH: 'REQUIRE_AUTH',
  ABORT: 'ABORT',
  PAUSE: 'PAUSE',
  ERROR: 'ERROR',
  SKIP: 'SKIP',
};
